<div class="modal-body">

	<div class="d-flex align-items-center">
		<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tab stepper-wrapper w-100" [destroyOnHide]="true"
			(navChange)="nextTab($event)">
			<li data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_TAB" class="stepper" [ngbNavItem]="1">
				<a data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_TAB_BTN" ngbNavLink>
					<div class="stepper-icon" [class.success]="activeTab == 2">
						1<i class="material-icons">done</i>
					</div>
					<div class="stepper-label">{{ labels().IMAGE_GARAGE_COMPONENT_ORIENTATION_TAB }}</div>
				</a>
				<ng-template ngbNavContent>
					<div class="row">
						<div class="col">
							@if (isRotate) {
							<image-edit tool="rotate" [isResetAnalysisWarning]="isResetAnalysisWarning"
								(changed)="isImgEdited = true" />
							} @else {
							<image-orientation [form]="categValue" (changed)="updateOrientation($event)"
								[(isCorrect)]="isOrientationCorrect" [isFulllegVisible]="isFulllegConfirmVisible()"
								[(isFullLeg)]="isFullleg" [isValidationForced]="isValidationForced()"
								[isResetAnalysisWarning]="isResetAnalysisWarning" />
							}
						</div>
					</div>
				</ng-template>
			</li>
			<li data-testid="SUBSYS2_CATEGORIZATION_CALIBRATION_TAB" class="stepper" [ngbNavItem]="2">
				<a data-testid="SUBSYS2_CATEGORIZATION_CALIBRATION_TAB_BTN" ngbNavLink>
					<div class="stepper-icon">
						2<i class="material-icons">done</i>
					</div>
					<div class="stepper-label">{{ labels().IMAGE_GARAGE_COMPONENT_CALIBRATION_TAB }}</div>
				</a>
				<ng-template ngbNavContent>
					<image-calibration [form]="calibrationForm" [ringCalibData]="ringCalibData"
						[isResetAnalysisWarning]="isResetAnalysisWarning" />
				</ng-template>
			</li>
		</ul>

		<button data-testid="SUBSYS2_CATEGORIZATION_CLOSE_BTN" type="button" class="btn-close btn-close-white mx-0"
			data-dismiss="modal" aria-label="Close" (click)="closeModal()" ngbAutoFocus>
		</button>

	</div>


	<div class="categorization-container">

		<div class="row flex-nowrap position-relative mx-2 w-100">
			@if (activeTab == 2) {
			<button data-testid="SUBSYS2_CATEGORIZATION_ARROW_PREV_BTN" class="stepper-arrow" (click)="prev()">
				<i class="material-icons">arrow_left</i>
			</button>
			}
			<button data-testid="SUBSYS2_CATEGORIZATION_ARROW_NEXT_BTN" class="stepper-arrow right"
				[class.animated]="isTabNextEnabled" (click)="next()"
				[ngbTooltip]="activeTab === 2 && isTabNextEnabled ? garageTooltipContent : null" placement="top"
				tooltipClass="white-tooltip" container="body" triggers="hover">
				<i class="material-icons">arrow_right</i>
			</button>

			<div class="categorization-tools-container">
				@if (activeTab === 1) {
				<edit-tools (sliderChanged)="isImgEdited = true" (resetted)="resetOrientation()" />
				}
			</div>

			<div class="col-6 col-xl-7 col-xxl-8">

				<div id="categorization-canvas-container" class="categorization-canvas-container">
					<!-- LEFT VIEW LABELS -->
					@if (leftLabel()) {
					<div data-testid="SUBSYS2_CATEGORIZATION_CANVAS_LEFT_LBL" class="btn-xray left">
						{{leftLabel()}}
					</div>
					}

					<!-- RIGHT VIEW LABELS -->
					@if (rightLabel()) {
					<div data-testid="SUBSYS2_CATEGORIZATION_CANVAS_RIGHT_LBL" class="btn-xray right">
						{{rightLabel()}}
					</div>
					}

					<!-- TOP VIEW LABELS -->
					@if (topLabel()) {
					<div data-testid="SUBSYS2_CATEGORIZATION_CANVAS_TOP_LBL" class="btn-xray top">
						{{topLabel()}}
					</div>
					}

					<!-- BOTTOM VIEW LABELS -->
					@if (bottomLabel()) {
					<div data-testid="SUBSYS2_CATEGORIZATION_CANVAS_BOTTOM_LBL" class="btn-xray bottom">
						{{bottomLabel()}}
					</div>
					}

					<!-- WIDGET ZOOM -->
					<div class="widget-zoom">
						<div data-testid="SUBSYS2_CATEGORIZATION_CANVAS_FULLSCREEN_BTN" class="btn-zoom"
							[title]="labels().IMAGE_GARAGE_COMPONENT_FIT_TO_VIEW" (click)="fitToView()" (keypress)="fitToView()">
							<i class="material-icons">fullscreen</i>
						</div>
						<div data-testid="SUBSYS2_CATEGORIZATION_CANVAS_ZOOMIN_BTN" class="btn-zoom"
							[title]="labels().IMAGE_GARAGE_COMPONENT_ZOOM_IN" (click)="zoomIn()" (keypress)="zoomIn()">
							<i class="material-icons">add</i>
						</div>
						<div data-testid="SUBSYS2_CATEGORIZATION_CANVAS_ZOOMOUT_BTN" class="btn-zoom"
							[title]="labels().IMAGE_GARAGE_COMPONENT_ZOOM_OUT" (click)="zoomOut()" (keypress)="zoomOut()">
							<i class="material-icons">remove</i>
						</div>
					</div>

					<div id="categorization-canvas" class="categorization-canvas"></div>
				</div>

			</div>

			<div class="col">
				<div [ngbNavOutlet]="nav"></div>
			</div>

		</div>

	</div>
</div>


<!-- Garage save tooltip -->
<ng-template #garageTooltipContent>
	<span [innerHTML]="labels().IMAGE_GARAGE_COMPONENT_SAVE_TOOLTIP"></span>
</ng-template>